// Aboutus.jsx
import React from 'react';
import './About.css'; // Import CSS

function Aboutus() {
  return (
    <div className="aboutus-container">
      {/* Hero Section */}
      <div className="hero-section">
        <h1 className="hero-title">About Us</h1>
        <div className="underline"></div>
        <p className="hero-text">
          At WaterSprint, we believe in the power of technology to address the world's most pressing challenges. As the innovation studio of the WaterSprint group, we are at the forefront of digital transformation, seamlessly integrating cutting-edge software engineering with specialized climate science and precise quantity surveying expertise.
        </p>
      </div>
    </div>
  );
}

export default Aboutus;